/**
 * Single shared place for the operator app's monetary display convention,
 * mirroring the customer app's `lib/currency.ts` spec — `de-DE` grouping, EUR,
 * whole Euro.
 *
 * It exists as one module so the next operator surface has something to import
 * instead of declaring a fifth per-page `Intl.NumberFormat`: the read-only
 * valuation surfaces rendered every amount bare precisely because the unit was
 * never tied to anything shared (IMM-644). `properties.tsx` and
 * `properties/detail.tsx` predate this and can migrate.
 */
export const euroFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});
